'use client';

import { forwardRef, useContext } from 'react';

import { css, cx } from '@/styled-system/css';

import { FormFieldContext } from '../form-field/context/form-field.context';
import { inputRecipe } from './styles/input.styles';
import type { InputPropsInterface } from './types/input.types';

/**
 * @since 1.3.0
 */

export const Input = forwardRef<HTMLInputElement, InputPropsInterface>(
  (props: InputPropsInterface, forwardedRef) => {
    const formFieldContext = useContext(FormFieldContext);

    const {
      className,
      css: cssProp,
      fluid = true,
      size = 'md',
      disabled = formFieldContext.disabled || false,
      error = formFieldContext.error || false,
      readOnly = formFieldContext.readOnly || false,
      required = formFieldContext.required || false,
      type = 'text',
      ...rest
    } = props;

    const styles = css(inputRecipe.raw({ size, disabled, fluid, error, readOnly }), cssProp);

    return (
      <input
        aria-describedby={formFieldContext.descriptionId}
        aria-invalid={error || undefined}
        ref={forwardedRef}
        className={cx('c11n', 'c11n_input', styles, className)}
        data-c11n-component="Input"
        data-c11n-version={__C11N_VERSION__}
        id={formFieldContext.controlId}
        type={type}
        disabled={disabled}
        required={required}
        readOnly={readOnly}
        {...rest}
      />
    );
  },
);

Input.displayName = 'Input';
